export const MAX_FIELD_LENGTH = 255 as const;
export const PAGE_MARGIN_X = 24;
export const MAX_NUMBER = 1e14;
export const MAX_VOTES_PER_USER = 10000;
export const SEVERITY_DEGRADED_THRESHOLD = 4102;
export const SEVERITY_NORMAL_THRESHOLD = 3165;
